export const statusData = {
  0: '进行中',
  2: '已完成'
}

export const statusDataCard = {
  0: '未审核',
  1: '审核通过',
  2: '审核不通过'
}

export const feedTypeData = {
  1: '功能优化',
  2: '积分机制',
  3: '系统BUG',
  4: '其他'
}

export const typeStore = {
  1: '公立',
  2: '私立'
}
